// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectBMCounterMessage } from '@shared/utils/DirectMessages/DirectBMCounterMessage';
export class BMCounterMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const msg = new DirectBMCounterMessage();
        const len = fieldSet.Count();
        for (let i = 0; i < len; i++) {
            const fixField = fieldSet.fieldSet[i];
            if (fixField.FieldId === 0) {
                continue;
            }
            if (fixField.FieldId === FieldsFactory.FIELD_COUNT) {
                const arr = fixField.Value;
                if (arr) {
                    msg.UnreadIDs = arr;
                }
            }
        }
        return [msg];
    }
}
